var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotificationIconChat = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22305 10.5C7.49627 10.5 7.65524 10.2986 7.65524 9.9938V8.56818H8.17685C9.26975 8.56818 10 7.80372 10 6.6312V2.38017C10 1.19731 9.26478 0.5 8.16692 0.5H1.83309C0.690512 0.5 0 1.19731 0 2.38017V6.6312C0 7.80372 0.690512 8.56818 1.83309 8.56818H4.96274L6.67164 10.1901C6.90015 10.4019 7.03428 10.5 7.22305 10.5Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotificationIconChat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/notification-icon-chat.0495c5a837cec85086642b740599a8ab.svg";